export const localizeConfig = {
    key: "weulmpC5ddpyV",
    rememberLanguage: true,
    autoDetectLanguage: true,
    autoApprove: true,
    enableResilientDOMMode: true,
    blockedClasses: [
        "material-symbols-outlined",
        "nextjs-container-errors-header",
        "nextjs-container-errors-body",
        "notranslate"
    ]
};

export const thirdPartyDisabledPrefixes: string[] = ["/experiment", "/onboarding/"];
export const thirdPartyDisabledExactPaths: string[] = [];
export const thirdPartyOnboardingWhitelist: string[] = [
    "/auth/confirm-email",
    "/auth/create-password",
    "/auth/forgot-pass",
    "/auth/loader",
    "/auth/set-email",
    "/auth/set-password",
    "/auth/verify-code",
    "/app-onboarding",
    "/experiment/success-payment"
];
export const localizeScriptUrl = "https://global.localizecdn.com/localize.js";
